// extracted by mini-css-extract-plugin
export default {"iconLightTheme":"IconLightTheme_iconLightTheme__4QAlE"};